const TOKEN_CAPTCHA_COOKIE_KEY = "captchaToken";
const TOKEN_CAPTCHA_COOKIE_KEY_AUX = "captchaTokenAux";

const setCookie = (cname, cvalue) => {
    const d = new Date();
    d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
const setCookieAux = (cname, cvalue) => {
    const d = new Date();
    d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

const getCookie = cname => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

const checkCookie = (key) => {
    let token = getCookie(key);
    return token;
}

export {
    TOKEN_CAPTCHA_COOKIE_KEY,
    TOKEN_CAPTCHA_COOKIE_KEY_AUX,
    setCookie,
    setCookieAux,
    getCookie,
    checkCookie
}